export default {
  title: '{type} migracja stan',
  confirmReset: {
    header: 'Zresetować status migracji {count} {type}?',
    message: 'Wszystkie {type} zostaną ponownie zmigrowane od pierwszych dostępnych danych w PT9800.',
  },
};
